/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Compare_IntegrationsInputs */

const en_why_listening_compare_integrations = /** @type {(inputs: Why_Listening_Compare_IntegrationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imports from the apps you already use`)
};

const es_why_listening_compare_integrations = /** @type {(inputs: Why_Listening_Compare_IntegrationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importa desde las apps que ya usas`)
};

/**
* | output |
* | --- |
* | "Imports from the apps you already use" |
*
* @param {Why_Listening_Compare_IntegrationsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_compare_integrations = /** @type {((inputs?: Why_Listening_Compare_IntegrationsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Compare_IntegrationsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_compare_integrations(inputs)
	return en_why_listening_compare_integrations(inputs)
});